import type { QueryClient } from '@tanstack/react-query'
import { trpc } from '@/lib/trpc'

/**
 * Refresh both detail queries and the paginated board/list cache — PLUS the
 * task timeline (activity rows + comment threads): every prop mutation
 * (status/priority/due date/assignee/outcome) writes an ACTIVITY entry
 * server-side, so the feed must refetch with the same gesture. Prefix-level
 * keys (no input) — only mounted queries actually refetch.
 */
export async function invalidateTaskBoardQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: trpc.task.board.queryKey(),
    }),
    queryClient.invalidateQueries({
      queryKey: trpc.task.board.infiniteQueryKey(),
    }),
    queryClient.invalidateQueries({
      queryKey: trpc.task.comments.queryKey(),
    }),
    queryClient.invalidateQueries({
      queryKey: trpc.comments.getNativeTaskComments.queryKey(),
    }),
  ])
}
